import "./Grupo.css"

import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";

import InsightImageRight from "../../components/Grupo/InsightImageRight/InsightImageRight";
import InsightImageLeft from "../../components/Grupo/InsightImageLeft/InsightImageLeft";

import CuboImg from "../../assets/grupos/Cubo.png";
import TimboxImg from "../../assets/grupos/Timbox.png";
import TaxImg from "../../assets/grupos/Tax.png";
import CaisatImg from "../../assets/grupos/Caisat.png";
import TumImg from "../../assets/grupos/Tum.png";

function Grupo() {
    return (
        <>
            <Navbar/>

            <main className="mainTop">
                <InsightImageRight
                    title="CUBO"
                    image={CuboImg}
                    description="La Red Social que inspira, conmueve y enseña a los jóvenes mexicanos."
                    category="La primera red social mexicana con propósito."
                    articleTitle="En CUBO, cada video importa."
                    readMoreUrl="https://www.cuboconecta.com/"
                />

                <InsightImageLeft
                    title="Timbox"
                    image={TimboxImg}
                    description="Exploramos tecnologías que permiten crear soluciones diferentes."
                    category="La seguridad fiscal de tu negocio es invaluable."
                    articleTitle="Hablemos de innovación y seguridad en timbrado fiscal."
                    readMoreUrl="https://www.timbox.com.mx/"
                />

                <InsightImageRight
                    title="TAX Company"
                    image={TaxImg}
                    description="La única empresa en Latinoamérica que cuenta con tecnología de última generación en la gama UAS."
                    category="Tax Company es una empresa mexicana con presencia en Europa."
                    articleTitle="Innovación y precisión para tu empresa."
                    readMoreUrl=""
                />

                <InsightImageLeft
                    title="CAISAT"
                    image={CaisatImg}
                    description="Tecnológicas que mejorarán diversos aspectos de la sociedad mexicana."
                    category="Soluciones tecnológicas prácticas para agricultura, medio ambiente, ciudades inteligentes y salud digital en México."
                    articleTitle="Nuevas ideas para transformar nuestro entorno."
                    readMoreUrl=""
                />

                <InsightImageRight
                    title="TUM"
                    image={TumImg}
                    description="Creamos soluciones personalizadas para empresas e instituciones."
                    category="Tecnología especializada en el desarrollo de software y plataformas digitales innovadoras."
                    articleTitle="Decisiones inteligentes a partir de información estratégica."
                    readMoreUrl=""
                />


            </main>

            <Footer />
        </>
    );
}

export default Grupo;
